module.exports = __webpack_public_path__ + "img/cross.f06dc5cd.svg";